import _orderBy from 'lodash/orderBy';
import { Link } from 'react-router-dom';
import './LinkedAdjustmentsSelectedItems.scss';
import { viewStructuredAnalysisPathForDocument } from '../../../../../common/services/urlService';
import { CloseButtonPill } from './components/CloseButtonPill';
import { LinkType } from './types/LinkType';

type SelectedLinkType = {
  documentCode: string;
  documentDisplayName: string;
  links: LinkType[];
};

type Props = {
  projectId: string;
  selectedLinks: SelectedLinkType[];
  onDelete: (link: LinkType) => void;
  canDelete: boolean;
};

const LinkedAdjustmentsSelectedItems = ({
  projectId,
  selectedLinks,
  onDelete,
  canDelete = false,
}: Props) => (
  <section className="link-adjustments-selected-items">
    {_orderBy(selectedLinks, [(item) => item.documentDisplayName]).map(
      (target) => {
        const { documentDisplayName, documentCode, links } = target;

        return (
          <div key={documentDisplayName} data-testid={documentDisplayName}>
            <div className="document-label">{documentDisplayName}</div>
            {links.map((link, index) => {
              const DeleteButton = () => (
                <CloseButtonPill
                  link={link}
                  index={index}
                  onDelete={onDelete}
                />
              );

              if (link.isBroken) {
                return (
                  <div
                    key={link.value}
                    data-testid={`${documentDisplayName}_${link.displayName}`}
                    className="link-target-adjustment-name strikethrough"
                  >
                    <span key={`link-target-${link.displayName}`}>
                      {link.displayName}
                    </span>
                    {canDelete && <DeleteButton />}
                  </div>
                );
              }
              const targetDocumentUrl = viewStructuredAnalysisPathForDocument(
                projectId,
                documentCode
              );
              return (
                <div key={link.value}>
                  <Link
                    className="link-target-adjustment-display-name"
                    to={{
                      pathname: targetDocumentUrl,
                      search: link.queryString,
                    }}
                    key={`link-target-${link.displayName}`}
                  >
                    <span>{link.displayName}</span>
                    {canDelete && <DeleteButton />}
                  </Link>
                </div>
              );
            })}
          </div>
        );
      }
    )}
  </section>
);

export default LinkedAdjustmentsSelectedItems;
